export enum SiteFrenchDsoEnum {
  enedis = "enedis",
  geredis = "geredis",
  bitche = "bitche",
}

export enum SiteFinlandDsoEnum {
  elenia = "elenia",
  caruna = "caruna",
  savon_voima = "savon_voima",
  jse = "jse",
  kymenlaakson = "kymenlaakson",
  pks = "pks",
  leppakosken_sahko_oy = "leppakosken_sahko_oy",
  alajarven = "alajarven_sahko_oy",
  enontekion = "enontekion_sahko_oy",
  esse_elektro_kraft = "esse_elektro_kraft_ab",
  haukiputaan = "haukiputaan_sahkoosuuskunta",
  herrfors = "herrfors_ab",
  imatran = "imatran_seudun_sahkonsiirto_oy",
  kajave = "kajave_oy",
  ksat = "koillis_satakunnan_sahko_oy",
  kss = "kss_verkko_oy",
  kuoreveden = "kuoreveden_sahko_oy",
  lahti = "lahti_energia_oy",
  lammaisten = "lammaisten_energia_oy",
  lreoy = "lappeenrannan_energiaverkot_oy",
  muonion = "muonion_sahkoosuuskunta",
  nivos = "nivos_verkot_oy",
  okun = "okun_energia_oy",
  oulun_energia = "oulun_energia_sahkoverkko_oy",
  paneliankosken = "paneliankosken_voima_oy",
  parikkalan = "parikkalan_valo_oy",
  porvoon = "porvoon_sahkoverkko_oy",
  rovakaira = "rovakaira_oy",
  sallila = "sallila_sahkonsiirto_oy",
  tls = "tls_verkko_oy",
  vaasan = "vaasan_sahkoverkko_oy",
  vakka_suomen = "vakka_suomen_voima_oy",
  valkeakosken = "valkeakosken_energia_oy",
  vatajankoski = "vatajankoski_sahkoverkko_oy",
  verkko = "verkko_korpela_oy",
  vetelin = "vetelin_energia_oy",
}

export const allDsoEnum = { ...SiteFrenchDsoEnum, ...SiteFinlandDsoEnum };
export type AllDsoEnum = SiteFrenchDsoEnum | SiteFinlandDsoEnum;

export enum SiteContryEnum {
  Finland = "Finland",
  France = "France",
  Sweden = "Sweden",
}

export enum SiteOperatorEnum {
  NW_JMET = "NW JMET",
  NW_JMET2 = "NW JMET2",
  NW_JMET3 = "NW JMET3",
  NW_JMET4 = "NW JMET4",
  NWJ_FIN_Oy = "NWJ FIN Oy",
  NWJ_FIN_2_Oy = "NWJ FIN 2 Oy",
  NWJ_SWE_AB = "NWJ SWE AB",
}

export enum SiteOptimizerEnum {
  NWRE = "NWRE",
  ELMY = "ELMY",
  SGE = "SGE",
  SYMPOWER = "SYMPOWER",
}

export enum SiteFranceSupplierEnum {
  NWRE = "NWRE",
  ELMY = "ELMY",
}

export enum SiteFinlandSupplierEnum {
  NWRE = "NWRE",
  Entelios = "Entelios",
}

export enum RteComputationVersionEnum {
  soc_reserve = 1,
  t_tenue = 3,
}

export enum PerformanceTypeEnum {
  msi = "msi",
  performance = "performance",
}

export enum PerformanceChronicleResultEnum {
  compliant = "compliant",
  acceptable = "acceptable",
  non_compliant = "non-compliant",
}

export enum ChronicleFilenamesEnum {
  essai_1bis = "essai_1bis.csv",
  essai_2v2 = "essai_2v2.csv",
  essai_3v2 = "essai_3v2.csv",
  essai_4v2 = "essai_4v2.csv",
  essai_5 = "essai_5.csv",
  r2_essai_2_file1 = "r2_essai_2_file1.csv",
  r2_essai_2_file2 = "r2_essai_2_file2.csv",
  r2_essai_1_file1 = "r2_essai_1_file1.csv",
  r2_essai_1_file2 = "r2_essai_1_file2.csv",
  r2_essai_1 = "r2_essai_1.csv",
  r2_essai_2 = "r2_essai_2.csv",
  fr_performance_8_racks_jbox1_17h = "fr_performance_8_racks_jbox1_17h.csv",
  fr_performance_8_racks_jbox1_20h30 = "fr_performance_8_racks_jbox1_20h30.csv",
  fr_performance_8_racks_jbox1_21h = "fr_performance_8_racks_jbox1_21h.csv",
  fr_performance_8_racks_jbox1_21h_v2 = "fr_performance_8_racks_jbox1_21h_v2.csv",
  fr_performance_10_racks_jbox1_18h = "fr_performance_10_racks_jbox1_18h.csv",
  fr_performance_10_racks_jbox1_21h = "fr_performance_10_racks_jbox1_21h.csv",
  fr_performance_10_racks_jbox1_21h30 = "fr_performance_10_racks_jbox1_21h30.csv",
  fr_performance_10_racks_jbox1_21h30_v2 = "fr_performance_10_racks_jbox1_21h30_v2.csv",
  fr_msi_jbox2_43h40 = "fr_msi_jbox2_43h40.csv",
  fr_msi_jbox2_27h15 = "fr_msi_jbox2_27h15.csv",
  fr_msi_jbox2_10_withdrawing_test_1000kW_155min = "fr_msi_jbox2_10_withdrawing_test_1000kW_155min.csv",
  fr_msi_jbox2_11_preparation_phase_120min = "fr_msi_jbox2_11_preparation_phase_120min.csv",
  fr_msi_jbox2_12_scale_injection_test_95min = "fr_msi_jbox2_12_scale_injection_test_95min.csv",
  fr_msi_jbox2_13_preparation_phase_30min = "fr_msi_jbox2_13_preparation_phase_30min.csv",
  fr_msi_jbox2_1_dynamic_test_10min = "fr_msi_jbox2_1_dynamic_test_10min.csv",
  fr_msi_jbox2_2_scale_withdrawing_test_130min = "fr_msi_jbox2_2_scale_withdrawing_test_130min.csv",
  fr_msi_jbox2_3_preparation_phase_130min = "fr_msi_jbox2_3_preparation_phase_130min.csv",
  fr_msi_jbox2_4_injection_test_pmax_130min = "fr_msi_jbox2_4_injection_test_pmax_130min.csv",
  fr_msi_jbox2_5_preparation_phase_180min = "fr_msi_jbox2_5_preparation_phase_180min.csv",
  fr_msi_jbox2_6_withdrawing_test_pmax_145min = "fr_msi_jbox2_6_withdrawing_test_pmax_145min.csv",
  fr_msi_jbox2_7_preparation_phase_195min = "fr_msi_jbox2_7_preparation_phase_195min.csv",
  fr_msi_jbox2_8_injection_test_1000kw_145min = "fr_msi_jbox2_8_injection_test_1000kw_145min.csv",
  fr_msi_jbox2_9_preparation_phase_180min = "fr_msi_jbox2_9_preparation_phase_180min.csv",
  fin_msi_roundtrip_pilote_project_29h = "fin_msi_roundtrip_pilote_project_29h.csv",
  fin_certification_fingrid_fcr_n_test_1_485min = "fin_certification_fingrid_fcr-n_test_1_485min.csv",
  fin_certification_fingrid_fcr_n_test_1_515min = "fin_certification_fingrid_fcr-n_test_1_515min.csv",
  fin_certification_fingrid_fcr_n_test_1_540min = "fin_certification_fingrid_fcr-n_test_1_540min.csv",
  fin_certification_fingrid_fcr_n_test_2_22min = "fin_certification_fingrid_fcr-n_test_2_22min.csv",
  fin_certification_fingrid_fcr_n_sin10_300_1h20 = "fin_certification_fingrid_fcr-n_sin10-300_1h20.csv",
  fin_certification_fingrid_fcr_d_up_test_1_160min = "fin_certification_fingrid_fcr-d_up_test_1_160min.csv",
  fin_certification_fingrid_fcr_d_down_test_1_130min = "fin_certification_fingrid_fcr-d_down_test_1_130min.csv",
  fin_certification_fingrid_fcr_d_up_test_2_20min = "fin_certification_fingrid_fcr-d_up_test_2_20min.csv",
  fin_certification_fingrid_fcr_d_down_test_2_20min = "fin_certification_fingrid_fcr-d_down_test_2_20min.csv",
  fin_certification_fingrid_fcr_d_up_test_3_80min = "fin_certification_fingrid_fcr-d_up_test_3_80min.csv",
  fin_certification_fingrid_afrr = "fin_certification_fingrid_afrr.csv",
  swe_msi_jbox2_1_mfrr_up_test_SE2_UTC = "swe_msi_jbox2_1_mfrr_up_test_SE2_UTC.csv",
  swe_msi_jbox2_1_mfrr_down_test_SE2_UTC = "swe_msi_jbox2_1_mfrr_down_test_SE2_UTC.csv",
  swe_msi_jbox2_1_mfrr_down_direct_SE2_UTC_50min = "swe_msi_jbox2_1_mfrr_down_direct_SE2_UTC_50min.csv",
  swe_msi_jbox2_1_mfrr_up_direct_SE2_UTC_50min = "swe_msi_jbox2_1_mfrr_up_direct_SE2_UTC_50min.csv",
}

export enum PlanningModeEnum {
  soc_management = "soc_management",
  fcr_rte_v2 = "fcr_rte_v2",
  fcr_rte_v2_certification = "fcr_rte_v2_certification",
  fcr_rte_v2_no_reserve = "fcr_rte_v2_no_reserve",
  afrr_rte = "afrr_rte",
  afrr_fcr_rte = "afrr_fcr_rte",
  power_chronicle = "power_chronicle",
  power = "power",
  stop = "stop",
  fingrid_fcrn = "fingrid_fcrn",
  fingrid_fcrd = "fingrid_fcrd",
  fingrid_afrr = "fingrid_afrr",
}

export enum FrancePlanningModeEnum {
  soc_management = "soc_management",
  fcr_rte_v2 = "fcr_rte_v2",
  fcr_rte_v2_certification = "fcr_rte_v2_certification",
  fcr_rte_v2_no_reserve = "fcr_rte_v2_no_reserve",
  afrr_rte = "afrr_rte",
  afrr_fcr_rte = "afrr_fcr_rte",
  power_chronicle = "power_chronicle",
  power = "power",
  stop = "stop",
}

export enum FinlandPlanningModeEnum {
  soc_management = "soc_management",
  power_chronicle = "power_chronicle",
  power = "power",
  stop = "stop",
  fingrid_fcrn = "fingrid_fcrn",
  fingrid_fcrd = "fingrid_fcrd",
  fingrid_afrr = "fingrid_afrr",
}

export enum FrancePlanningMaskModeEnum {
  r2_asymmetrical = "r2_asymmetrical",
  r2_chronicles = "r2_chronicles",
  r1_chronicles = "r1_chronicles",
  enspired = "enspired",
  r1_r2_mask = "r1_r2_mask",
  technical_chronicle = "technical_chronicle",
  arbitrage_spot = "arbitrage_spot",
  fake_box_staging = "fake_box_staging",
  standby_france = "standby_france",
  r1_r2_target_soc_band_tests = "r1_r2_target_soc_band_tests",
  r2_asymmetrical_test = "r2_asymmetrical_test",
  fcr_standalone = "fcr_standalone",
  r2_standalone = "r2_standalone",
  r2_tests = "r2_tests",
  france_intraday_standalone = "france_intraday_standalone",
  france_intraday_standalone_multisite = "france_intraday_standalone_multisite",
  external = "external",
  r2_capa_asymmetrical = "r2_capa_asymmetrical",
}

export enum FinlandPlanningMaskModeEnum {
  fcrn_standalone = "fcrn_standalone",
  fcrd_standalone = "fcrd_standalone",
  fcrd_fcrn_combined = "fcrd_fcrn_combined",
  r2_finland = "r2_finland",
  finland_r2_asymmetrical = "finland_r2_asymmetrical",
  standby_finland = "standby_finland",
  multi_market_fcr_finland = "multi_market_fcr_finland",
  finland_intraday_standalone = "finland_intraday_standalone",
  finland_intraday_standalone_multisite = "finland_intraday_standalone_multisite",
  finland_mFRR_asymmetrical = "finland_mFRR_asymmetrical",
  finland_afrr_intraday = "finland_afrr_intraday",
  finland_afrr_intraday_dp = "finland_afrr_intraday_dp",
  finland_afrr_intraday_dp_qh_ph = "finland_afrr_intraday_dp_qh_ph",
  finland_mfrr_intraday = "finland_mfrr_intraday",
  finland_afrr_mfrr_intraday = "finland_afrr_mfrr_intraday",
  sweden_intraday_standalone = "sweden_intraday_standalone", //enum Suédois à créer ultérieurement
}

export interface MaskType {
  end_date: string;
  operating_mode: string;
  operator_name: string;
  site_id: number;
  start_date: string;
}

export enum FranceGroupTypeEnum {
  rte_edr = "rte_edr",
  rte_edp = "rte_edp",
  rte_edc = "rte_edc",
  rte_eda = "rte_eda",
  lardit = "lardit",
  intraday_elmy = "intraday_elmy",
}
export enum FinlandGroupTypeEnum {
  fingrid_pe = "fingrid_pe",
  fingrid_ro = "fingrid_ro",
}

export enum GroupTypeEnum {
  rte_edr = "rte_edr",
  rte_edp = "rte_edp",
  rte_edc = "rte_edc",
  rte_eda = "rte_eda",
  fingrid_pe = "fingrid_pe",
  fingrid_ro = "fingrid_ro",
  lardit = "lardit",
  intraday_elmy = "intraday_elmy",
}

export enum FormattedGroupTypeEnum {
  rte_edr = "EDR",
  rte_edp = "EDP",
  rte_edc = "EDC",
  rte_eda = "EDA",
  fingrid_pe = "FIN_PE",
  fingrid_ro = "FIN_RO",
}

export enum GroupModeEnum {
  prod = "prod",
  test = "test",
}

export enum MaintenanceTypeEnum {
  Enedis = "enedis",
  Preventive = "preventive",
  Fortuit = "fortuit",
  RE = "re",
}

export enum SiteModeEnum {
  test = "test",
  factory_trials = "factory_trials",
  operational_trials = "operational_trials",
  tso_trials = "tso_trials",
  production = "production",
}

export enum DirectionEnum {
  UPWARD = "UPWARD",
  DOWNWARD = "DOWNWARD",
}

export enum AfrrPointStatusEnum {
  NOT_SENT = "NOT_SENT",
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  PARTIALLY_ACCEPTED = "PARTIALLY_ACCEPTED",
  OBSOLETE = "OBSOLETE",
  REFUSED = "REFUSED",
  REJECTED = "REJECTED",
}

export enum TopNiveauGateStatusEnum {
  NOT_SENT = "NOT_SENT",
  PENDING = "PENDING",
  ACKNOWLEDGED = "ACKNOWLEDGED",
  PARTIALLY_ACKNOWLEDGED = "PARTIALLY_ACKNOWLEDGED",
  OBSOLETE = "OBSOLETE",
  REFUSED = "REFUSED",
}

export enum TITypeEnum {
  P_PROD = "P.PROD",
  PART_FSM = "PART.FSM",
  F_PROD = "F.PROD",
  PC = "PC",
  SOC_EDR = "SOC.EDR",
  RSFP = "RSFP",
  N_RSFP = "N.RSFP",
  RET_RSFP = "RET.RSFP",
}

export enum PacketTypeEnum {
  TM = "TM",
  TS = "TS",
  TVC = "TVC",
}

export enum RteCommunicationMarketTypeEnum {
  fcr = "fcr",
  afrr = "afrr",
}

export enum RteCommunicationMarketStatusEnum {
  enabled = "enabled",
  disabled = "disabled",
}

export enum RteCommunicationTestConfigTypeEnum {
  nlevel_loss = "nlevel_loss",
  nlevel_simulation = "nlevel_simulation",
}

export enum MaskOperationModeEnum {
  fcr_standalone = "fcr_standalone",
  r2_standalone = "r2_standalone",
  r2_tests = "r2_tests",
  r2_chronicles = "r2_chronicles",
}

/* Finland Communication */

export enum FinlandCommunicationProtocolTypeEnum {
  MODBUS = "MODBUS",
  C104 = "C104",
  ICCP = "ICCP",
}

export enum FinlandCommunicationServiceOperatorEnum {
  DSO = "DSO",
  TSO = "TSO",
}

export enum FinlandCommunicationAssetLevelEnum {
  SITE = "SITE",
  PARC = "PARC",
  PROVIDING_ENTITY = "PROVIDING_ENTITY",
}

export enum FinlandCommunicationDirectionEnum {
  SENT = "SENT",
  RECEIVED = "RECEIVED",
}

export enum FinlandCommunicationFieldTypeEnum {
  BOOLEAN = "BOOLEAN",
  INTEGER = "INTEGER",
  FLOAT = "FLOAT",
}
